import { CmsObjectWithDefault } from '@components/Cms/types';

export type RegisterPasskeyFormCmsKey =
    | 'NavigationTitle'
    | 'Title'
    | 'BodyText1'
    | 'BodyText2'
    | 'LearnMore'
    | 'CreatePasskey'
    | 'NotNow'
    | 'RegisterPasskeySuccess'
    | 'FaqTitle'
    | 'FaqHeader1'
    | 'FaqText1'
    | 'FaqHeader2'
    | 'FaqText2'
    | 'FaqHeader3'
    | 'FaqText3';

// test-safe
export const RegisterPasskeyFormCmsWithDefault: CmsObjectWithDefault<RegisterPasskeyFormCmsKey> = {
    NavigationTitle: {
        cmsId: 541400,
        defaultTranslation: 'Passkeys',
    },
    Title: {
        cmsId: 541401,
        defaultTranslation: 'Sign in next time with a single click!',
    },
    BodyText1: {
        cmsId: 541402,
        defaultTranslation: 'A passkey lets you sign in without your password.',
    },
    BodyText2: {
        cmsId: 541403,
        defaultTranslation: 'With passkeys, you can log in to Agoda with Face ID, Touch ID or screen lock.',
    },
    LearnMore: {
        cmsId: 541404,
        defaultTranslation: 'Learn more',
    },
    CreatePasskey: {
        cmsId: 541405,
        defaultTranslation: 'Create a passkey',
    },
    NotNow: {
        cmsId: 541406,
        defaultTranslation: 'Not now',
    },
    RegisterPasskeySuccess: {
        cmsId: 541407,
        defaultTranslation: 'Passkey created',
    },
    FaqTitle: {
        cmsId: 541409,
        defaultTranslation: 'Passkey FAQ',
    },
    FaqHeader1: {
        cmsId: 541410,
        defaultTranslation: 'What is a passkey?',
    },
    FaqText1: {
        cmsId: 541411,
        defaultTranslation:
            "Passkeys are a safer replacement for passwords that can't be reused, phished, or breached. They let you sign in with just your fingerprint, face scan, or screen lock.",
    },
    FaqHeader2: {
        cmsId: 541412,
        defaultTranslation: 'Why using a passkey?',
    },
    FaqText2: {
        cmsId: 541413,
        defaultTranslation:
            "Simple: Passkeys let you easily sign in to your Agoda account using your device's lock method, such as fingerprint, face, pin, or pattern.\\n\\nSecure: Passkeys are more secure than passwords, because they're uniquely generated for every account and are less vulnerable to phishing. Passkey information is stored on your device. Your biometric data, such as a fingerprint or face scan, is never shared with Agoda.\\n\\nPrivate: Your biometric data, like fingerprints or face scans, is stored on your device and never shared with Agoda.",
    },
    FaqHeader3: {
        cmsId: 541414,
        defaultTranslation: 'How do passkeys work?',
    },
    FaqText3: {
        cmsId: 541415,
        defaultTranslation:
            "When you create a passkey, you won't need to enter your password to access your Agoda account. You can also do things such as auto-fill your payment information.\\n\\nTo verify that it's you, you'll use your fingerprint, facial recognition, or your device passcode.",
    },
};
